export default __webpack_public_path__ + "static/media/signin-img.2576cc83.png";